import React, { useEffect } from 'react';
import { useTranslation } from "react-i18next"
import { CountrySwitcher } from '../features/countrySwitcher/CountrySwitcher';
import { Language } from '../features/language/Language';
import { Container, Row, Col, Nav, } from 'react-bootstrap';
import { Download } from './Download';
import { Sections } from './Sections';
import { Loading } from './Loading';
import { Link } from 'react-router-dom';
import { Features } from './Features';
import { useSelector } from 'react-redux';
import { getSelectedLanguage } from '../features/language/languageSlice';
import { getSelectedCountry } from '../features/countrySwitcher/countrySlice';
import { Intro } from './Intro';
import { SectionsBubble } from './SectionsBubble';
import { Country } from '../features/countrySwitcher/Country';
import { CountryBubble } from '../features/countrySwitcher/CountryBubble';

export const CountrySelectorPage = () => {
    const { t } = useTranslation();

    const selectedLanguage = useSelector(getSelectedLanguage);
    const selectedCountry = useSelector(getSelectedCountry);

    let banner = t('BANNER');
    useEffect(() => {

    })
    return (
        <>
            <div className='introbg'>
                <Container>
                    <Row>
                        <Col>
                            <Intro />
                        </Col>
                    </Row>
                </Container>
            </div>
            <div className="sections">
                <Container>
                    <Row>
                        <Col>
                            <CountryBubble />
                        </Col>
                    </Row>
                </Container>
            </div>
            <div className='downloadbg'>
                <Container>
                    <Row>
                        <Col>
                            <Download />
                        </Col>
                    </Row>
                </Container>
            </div>
        </>
    );
}